/*
 * Lae Landing — Quiz popup logic
 */
(function(){
  var ans = {};
  var step = 0;
  var steps = document.querySelectorAll('.lqz-step');
  var dots = [document.getElementById('lqzd0'),document.getElementById('lqzd1'),document.getElementById('lqzd2')];

  document.querySelectorAll('.lqz-opt').forEach(function(opt){
    opt.addEventListener('click', function(){
      var parent = this.closest('.lqz-step');
      parent.querySelectorAll('.lqz-opt').forEach(function(o){ o.classList.remove('picked'); });
      this.classList.add('picked');
      ans['q' + step] = this.getAttribute('data-v');
      setTimeout(function(){
        if(step === 2){
          showResult();
        } else {
          step++;
          steps.forEach(function(s){ s.classList.remove('active'); });
          document.getElementById('lqzs' + step).classList.add('active');
          dots.forEach(function(d,i){ if(i <= step) d.classList.add('done'); });
        }
      }, 300);
    });
  });

  function showResult(){
    steps.forEach(function(s){ s.classList.remove('active'); });
    document.querySelector('.lqz-bar').style.display = 'none';
    var r = getRecommendation(ans.q0, ans.q1, ans.q2);
    document.getElementById('lqzrn').textContent = r.name;
    document.getElementById('lqzrd').textContent = r.desc;
    document.getElementById('lqzrt').innerHTML = r.tags.map(function(t){ return '<span class="lqz-result-tag">' + t + '</span>'; }).join('');
    document.getElementById('lqzrl').href = r.url;
    document.getElementById('lqzr').classList.add('active');
  }

  function getRecommendation(obj, time, level){
    var challenges = {
      fresh: {
        name: 'Fresh Start Sculpt',
        desc: 'Programme express de 8 semaines sans \u00e9quipement. S\u00e9ances courtes de 20 \u00e0 25 minutes, parfait pour celles qui ont un horaire charg\u00e9.',
        tags: ['8 semaines', '20-25 min', 'Sans \u00e9quipement', 'Interm\u00e9diaire'],
        url: '/products/fresh-start-sculpt-challenge-8-weeks'
      },
      tone: {
        name: 'Tone + Burn : Abs + Booty',
        desc: 'Programme cibl\u00e9 de 6 semaines pour sculpter tes abdos et tes fessiers. Maison et gym.',
        tags: ['6 semaines', 'Abdos + fessiers', 'Maison et gym'],
        url: '/products/tone-burn-abs-booty-%F0%9F%92%A5-debut-1er-mai'
      },
      cut: {
        name: 'Cut + Strong',
        desc: 'Programme intensif de 8 semaines pour perdre du gras tout en gagnant en force. Pour celles qui veulent des r\u00e9sultats s\u00e9rieux.',
        tags: ['8 semaines', 'Maison et gym', 'Interm\u00e9diaire \u00e0 avanc\u00e9'],
        url: '/products/strong-mindset-strong-body-new-year-challenge'
      },
      thirty: {
        name: '30 Days \u2013 30 Minutes',
        desc: 'Le programme parfait pour commencer ! 30 jours de s\u00e9ances de 30 minutes \u00e0 la maison, sans \u00e9quipement. Id\u00e9al comme premier challenge.',
        tags: ['30 jours', '30 min', 'Maison seulement', 'D\u00e9butante'],
        url: '/products/30-days-30-min'
      },
      hyrox: {
        name: 'HYROX Prep',
        desc: 'Programme avanc\u00e9 de 6 semaines pour am\u00e9liorer ton cardio et devenir plus forte. S\u00e9ances intenses de 45 minutes.',
        tags: ['6 semaines', '45 min', 'Maison et gym', 'Avanc\u00e9'],
        url: '/products/the-come-back-challenge'
      },
      summer: {
        name: 'Summer Prep 3.0',
        desc: 'Programme complet de 8 semaines combinant fessiers, abdos et course. Avec \u00e9quipement, s\u00e9ances de 45 minutes.',
        tags: ['8 semaines', '45 min', 'Maison et gym', 'Fessiers + abdos + course'],
        url: '/products/summer-prep-3-0-pre-sale-starts-may-20th'
      }
    };

    if(obj === 'start' && level === 'deb') return challenges.thirty;
    if(obj === 'start' && level === 'inter') return challenges.fresh;
    if(obj === 'start' && level === 'adv') return challenges.cut;

    if(obj === 'perf') return challenges.hyrox;

    if(obj === 'booty' && time === 'long') return challenges.summer;
    if(obj === 'booty') return challenges.tone;

    if(obj === 'fat' && level === 'deb') return challenges.thirty;
    if(obj === 'fat' && time === 'short') return challenges.fresh;
    if(obj === 'fat' && level === 'adv') return challenges.cut;
    if(obj === 'fat' && time === 'long') return challenges.cut;
    if(obj === 'fat') return challenges.fresh;

    return challenges.fresh;
  }

  function lqzReset(){
    ans = {};
    step = 0;
    steps.forEach(function(s){ s.classList.remove('active'); });
    document.getElementById('lqzs0').classList.add('active');
    document.getElementById('lqzr').classList.remove('active');
    document.querySelector('.lqz-bar').style.display = 'flex';
    dots.forEach(function(d,i){ if(i > 0) d.classList.remove('done'); });
    document.querySelectorAll('.lqz-opt').forEach(function(o){ o.classList.remove('picked'); });
  }

  /* ── Event listeners (replaces inline onclick handlers) ── */
  var quizOverlay = document.getElementById('lqz');

  // Open quiz buttons
  document.querySelectorAll('[data-lae-quiz-open]').forEach(function(btn){
    btn.addEventListener('click', function(){ quizOverlay.classList.add('open'); });
  });

  // Close quiz (X button)
  document.querySelectorAll('[data-lae-quiz-close]').forEach(function(btn){
    btn.addEventListener('click', function(){ quizOverlay.classList.remove('open'); });
  });

  // Close quiz (click on overlay backdrop)
  quizOverlay.addEventListener('click', function(e){
    if(e.target === quizOverlay) quizOverlay.classList.remove('open');
  });

  // Restart quiz
  document.querySelectorAll('[data-lae-quiz-restart]').forEach(function(btn){
    btn.addEventListener('click', lqzReset);
  });
})();
